import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ProductImage } from './ProductImage';
export function HeroSection() {
  return <section className="relative pt-12 pb-10 px-4 overflow-hidden bg-slate-950" data-id="element-34">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-teal-900/30 blur-[120px] rounded-full pointer-events-none" data-id="element-35"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-5" data-id="element-37">
          <h1 className="text-2xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-1" data-id="element-38">
            NO TERMINES MÁS EL DÍA AGOTADO
          </h1>
          <h2 className="text-xl md:text-4xl lg:text-5xl font-black text-teal-400 leading-tight" data-id="element-39">
            PREPARÁ CON ANTICIPACIÓN TUS PROTOCOLOS
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-4 max-w-xs mx-auto" data-id="element-40">
          <ProductImage data-id="element-41" />
          <p className="text-center text-sm md:text-base text-slate-400 font-medium mt-4" data-id="element-42">
            Sistema profesional para dejar de improvisar y optimizar tu tiempo
            clínico.{' '}
            <span className="text-slate-300 font-semibold" data-id="element-43">
              Mejorá tu consultorio en una semana.
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-44">
          <CTAButton data-id="element-45" />
        </motion.div>
      </div>
    </section>;
}